// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S7u8","left":"styles_left__3ceEw"};